import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { jumpRoute, jumpLogin, loginUserUid } from "@/redux/action/routeInfo";
import { useDispatch, useSelector } from "react-redux";
import { formatTime, Storage, localStorageData } from "@/tools/until";
import Thumbnail from "@/components/thumbnail";
import "./index.scss";
import qs from "query-string";
import { Carousel, Avatar, Tabs, Spin, Empty, Button } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import {
  getPlateForyou,
  getPlateCommon,
  postRates,
  cancelPostRates,
  favtimesPlate,
  getPostsSection,
  getBanner,
  getPlateFollow,
  getRecommendMember,
  getTopics,
} from "@/api";
import { getMemberInfo, loginForWeb } from "@/api/member";
import {
  Foryou,
  Life,
  Photography,
  Tech,
  Sport,
  Video,
  Feedback,
  Pause,
  VideoIcon,
  FeedbackIcon,
  postIcon,
  Initial,
  News,
  Entertainment,
} from "@/assets/images";
import { useTranslation } from "react-i18next";

const { TabPane } = Tabs;

const contentStyle = {
  height: "100%",
  color: "#fff",
  textAlign: "center",
  background: "#364d79",
  cursor: "pointer",
  userSelect: "none",
};

const contrastName = (name) => {
  return {
    0: Foryou,
    1: Life,
    2: Tech,
    3: Photography,
    4: Sport,
    31: Entertainment,
    45: News,
  }[name];
};

const Store = () => {
  const location = useLocation().pathname;
  const dispatch = useDispatch();
  const [activeKey, setActiveKey] = useState("1");
  const [threadList, setThreadList] = useState([]); // 帖子
  const [loading, setLoading] = useState(true);
  const [threadLoading, setThreadLoading] = useState(false);
  const navigate = useNavigate();
  const [menuIndex, setMenuIndex] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [addMore, setAddMore] = useState(true);
  const [plateInfo, setPlateInfo] = useState([]);
  const [userInfo, setUserInfo] = useState({});
  const [tabList, setTabList] = useState([]);
  const [fid, setFid] = useState(0); // 板块id
  const [lifeOthersId, setLifeOthersId] = useState(null); // life板块下others的id
  const source = qs.parse(useLocation().search).source;
  const accessToken = qs.parse(useLocation().search).accessToken;
  const code = qs.parse(useLocation().search).countryCode;

  const isLogin = useSelector((state) => state.isLogin);
  const { t } = useTranslation();
  const userId = useSelector((state) => state.uid);
  const [bannerList, setBannerList] = useState([]);
  const [recommendMember, setRecommendMember] = useState([]);
  const [topicList, setTopic] = useState([]);

  const countryCode = useSelector((state) => state.countryCode);

  // banner跳转
  const bannerLink = (urlType, url) => {
    if (Number(urlType) === 2) {
      window.open(url, "_blank","noopener");
      // window.open(url)
    } else {
      navigate(`/detail?tid=${url}`);
    }
  };
  //评论头像跳转
  const jumpPage = (uid) => {
    if (uid === userId) {
      navigate("/my");
    } else {
      navigate(`/user?uid=${uid}`);
    }
  };

  // 跳转登录
  const jumpToLogin = () => {
    const callbackUrl = `${window.location.origin}/#/homepage`;
    if(window.location.hostname.indexOf("ind-spot.shalltry.com") > -1||window.location.hostname.indexOf("ind-tspot.tecno.com") > -1||window.location.hostname.indexOf("in-spot.tecno.com") > -1){
      window.location.href = `https://ind-page.palm.tech/palm-id/#/login?language=en_us&channel=1&brandId=tecnoid&client-id=hiaccount&callbackUrl=${callbackUrl}`
    }
    else{
      window.location.href = `https://page.palm.tech/palm-id/#/login?language=en_us&channel=1&brandId=tecnoid&client-id=hiaccount&callbackUrl=${callbackUrl}`

    }
  };
  // 切换板块
  const changePlateIndex = (id) => {
    document.documentElement.scrollTop = 500;
    setMenuIndex(id);
    setActiveKey("1");
    setPage(1);
    setFid(Number(id));
    const filteredList = plateInfo.filter((v) => v.id == id);
    const tempList = filteredList.length > 0 ? filteredList[0].subSection : [];
    setTabList(tempList);
    const tempId = (
      tempList.length ? tempList.map((v) => v.id) : [Number(id)]
    ).flatten(Infinity);
    // console.log(tempId);
    if (id === 0) {
      getHomeThreads();
    } else {
      setLoading(true);
      setThreadList([]);
      const params = {
        fid: Array.isArray(tempId) ? tempId : [tempId],
        mac: localStorageData.get("mark"),
        page: 1,
        pageSize,
      };
      getPlateCommon(params)
        .then((res) => {
          if (res.data.code === 0) {
            setThreadList(res.data.data);
            setLoading(false);
          }
        })
        .catch(() => {
          setThreadList([]);
          setLoading(false);
        });
    }
  };
  // 切换板块下的二级
  const changeTabIndex = (key) => {
    setActiveKey(key);
    setLoading(true);
    const id = Number(key) === 1 ? menuIndex : Number(key);
    if (id === 0) {
      const params = {
        mac: localStorageData.get("mark"),
        page: 1,
        pageSize,
      };
      getPlateForyou(params).then((res) => {
        setThreadList(res.data.data);
        setLoading(false);
      });
    } else {
      const subSection = plateInfo.filter((v) => v.id === fid)[0].subSection;
      const tempFid =
        Number(key) === 1
          ? subSection.length
            ? subSection.map((v) => v.id)
            : plateInfo.filter((v) => v.id === fid)[0].id
          : [Number(key)];
      const params = {
        fid: Array.isArray(tempFid) ? tempFid : [tempFid],
        mac: localStorageData.get("mark"),
        page: 1,
        pageSize,
      };
      getPlateCommon(params)
        .then((res) => {
          if (res.data.code === 0) {
            setThreadList(res.data.data);
            setLoading(false);
          }
        })
        .catch(() => {
          setThreadList([]);
          setLoading(false);
        });
    }
  };
  // 是否收藏
  const changePostFav = (tid, isFavorite) => {
    // console.log(tid, isFavorite);
    if (!isFavorite) {
      // 收藏
      const params = {
        delete: 0,
        tid,
      };
      favtimesPlate(params).then((res) => {
        if (res) {
          const tempList = JSON.parse(JSON.stringify(threadList));
          tempList.forEach((v) => {
            if (v.tid === tid) {
              v.favTimes += 1;
              v.isFavorite = true;
            }
          });
          // console.log(tempList);
          setThreadList(tempList);
        }
      });
    } else {
      // 取消收藏
      const params = {
        delete: 1,
        tid,
      };
      favtimesPlate(params).then((res) => {
        if (res) {
          const tempList = JSON.parse(JSON.stringify(threadList));
          tempList.forEach((v) => {
            if (v.tid === tid) {
              v.favTimes -= 1;
              v.isFavorite = false;
            }
          });
          setThreadList(tempList);
        }
      });
    }
  };
  // 是否点赞
  const changePostRate = (pid, isRate) => {
    if (isRate) {
      cancelPostLike(pid);
    } else {
      postLike(pid);
    }
  };
  // 点赞
  async function postLike(pid) {
    const params = {
      pid,
    };
    postRates(params).then((res) => {
      if (res) {
        const tempList = JSON.parse(JSON.stringify(threadList));
        tempList.forEach((v) => {
          if (v.pid === pid) {
            v.rates += 1;
            v.isRate = true;
          }
        });
        setThreadList(tempList);
      }
    });
  }
  // 取消点赞
  async function cancelPostLike(pid) {
    const params = {
      pid,
    };
    cancelPostRates(params).then((res) => {
      if (res) {
        const tempList = JSON.parse(JSON.stringify(threadList));
        tempList.forEach((v) => {
          if (v.pid === pid) {
            v.rates -= 1;
            v.isRate = false;
          }
        });
        setThreadList(tempList);
      }
    });
  }
  // 获取For you板块
  async function getHomeThreads() {
    setLoading(true);
    setThreadList([]);
    const params = {
      mac: localStorageData.get("mark"),
      page: 0,
      pageSize,
    };
    const res = await getPlateFollow(params);
    setThreadList(res.data.data);
    setLoading(false);
  }
  // 获取板块信息
  async function getPageSection() {
    const res = await getPostsSection({});
    const tempList = [
      {
        id: 0,
        name: t("store.name3"),
        subSection: [],
      },
      ...JSON.parse(JSON.stringify(res.data.data)),
    ];
    setPlateInfo(tempList);
    const tempTabList = tempList.filter((v) => v.id == 0)[0].subSection;
    setTabList(tempTabList);
    const tempId = tempList
      .filter((item) => item.id === 1)[0]
      .subSection.filter((v) => v.id === 16)[0].id;
    setLifeOthersId(tempId);
  }

  // 滚动请求数据
  const askForData = () => {
    const scrollTop = document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;
    if (scrollHeight - clientHeight <= scrollTop) {
      if (addMore) {
        setAddMore(false);
        const tempPage = page + 1;
        setPage(tempPage);
        setTimeout(() => {
          setAddMore(true);
        }, 2000);
        setThreadLoading(true);
        if (fid === 0) {
          const params = {
            mac: localStorageData.get("mark"),
            page: page + 1,
            pageSize,
          };
          getPlateForyou(params).then((res) => {
            const temp = threadList.concat(res.data.data);
            setThreadList(temp);
            setThreadLoading(false);
          });
        } else {
          const subSection = plateInfo.filter((v) => v.id === fid)[0]
            .subSection;
          const tempFid =
            Number(activeKey) === 1
              ? subSection.length
                ? subSection.map((v) => v.id)
                : plateInfo.filter((v) => v.id === fid)[0].id
              : [Number(activeKey)];
          const params = {
            fid: Array.isArray(tempFid) ? tempFid : [tempFid],
            mac: localStorageData.get("mark"),
            page: page + 1,
            pageSize,
          };
          getPlateCommon(params).then((res) => {
            const temp = threadList.concat(res.data.data);
            setThreadList(temp);
            setThreadLoading(false);
          });
        }
      }
    }
  };

  const toPost = () => {
    if (Storage.get("tokens")) {
      dispatch(jumpRoute(location));
      // getQuestion();
      if (Storage.get("tokens")) {
        navigate(`/post`);
      }
    } else {
      const callbackUrl = `${window.location.origin}/#/homepage`;
      if(window.location.hostname.indexOf("ind-spot.shalltry.com") > -1||window.location.hostname.indexOf("ind-tspot.tecno.com") > -1||window.location.hostname.indexOf("in-spot.tecno.com") > -1){
        window.location.href = `https://ind-page.palm.tech/palm-id/#/login?language=en_us&channel=1&brandId=tecnoid&client-id=hiaccount&callbackUrl=${callbackUrl}`
      }
      else{
        window.location.href = `https://page.palm.tech/palm-id/#/login?language=en_us&channel=1&brandId=tecnoid&client-id=hiaccount&callbackUrl=${callbackUrl}`
  
      }
    }
  };

  // 监听路由
  useEffect(() => {
    getRecommendMember()
      .then((res) => {
        if (res.data.code === 0) {
          setRecommendMember(res.data.data);
          console.log(res.data.data);
        }
      })
      .catch(() => {
        setRecommendMember([]);
      });
    const params = {
      mac: localStorageData.get("mark"),
      page: 1,
      pageSize,
    };
    getTopics(params)
      .then((res) => {
        if (res.data.code === 0) {
          setTopic(res.data.data);
        }
      })
      .catch(() => {
        setTopic([]);
      });

    setMenuIndex(0);
    getBanner()
      .then((res) => {
        if (res.data.code === 0) {
          setBannerList(res.data.data);
        }
      })
      .catch(() => {
        setBannerList([]);
      });

    dispatch(jumpRoute(location));
   
    if (source) {
      let newtoken=JSON.parse(decodeURIComponent(accessToken))
      console.log(newtoken,'accessTokenaccessTokenaccessToken')
      Storage.set("tokens", newtoken);
      Storage.set("source", source);
      Storage.set("countryCode", code);
      console.log(code);
      getPageSection();
      getHomeThreads();
      dispatch(jumpLogin(true));
      getMemberInfo(newtoken).then((res) => {
        setUserInfo(res.data.data);
        const { uid } = res.data.data;
        dispatch(loginUserUid(uid));
        Storage.set("uid", uid);
      });
    } else {
      if (accessToken) {
        // let newtoken=JSON.parse(decodeURIComponent(accessToken))
        Storage.set("accessToken", accessToken);
        Storage.set("site", code);
        loginForWeb(accessToken).then((res) => {
          if (res) {
            Storage.set("tokens", res.data.data.tspotToken);
            getPageSection();
            getHomeThreads();
            dispatch(jumpLogin(true));
            getMemberInfo(res.data.data).then((res) => {
              setUserInfo(res.data.data);
              const { uid } = res.data.data;
              dispatch(loginUserUid(uid));
              Storage.set("uid", uid);
            });
          }
        });
      } else {
        if (Storage.get("tokens")) {
          const tokens = Storage.get("tokens");
          getPageSection();
          getHomeThreads();
          dispatch(jumpLogin(true));
          getMemberInfo(tokens).then((res) => {
            setUserInfo(res.data.data);
            const { uid } = res.data.data;
            dispatch(loginUserUid(uid));
            Storage.set("uid", uid);
          });
        } else {
          getPageSection();
          getHomeThreads();
          dispatch(jumpLogin(false));
        }
      }
    }
  }, [countryCode]);

  useEffect(() => {
    window.addEventListener("scroll", askForData);
    return () => {
      window.removeEventListener("scroll", askForData);
    };
  });

  return (
    <div className="homePage">
      <div className="homePage-layout">
        <div className="homePage-content">
          {/* <div className="homePage-recommend">
            <div className="mine-introduction">
              {isLogin && userInfo ? (
                <>
                  <Avatar
                    src={userInfo.avatarImg}
                    size={72}
                    onClick={() => navigate("/my")}
                    style={{ cursor: "pointer" }}
                  />
                  <div className="mine-description">
                    <div className="mine-name">{userInfo.username} </div>
                  </div>
                </>
              ) : (
                <>
                  <Avatar src={Initial} size={72} />
                  <div className="mine-description">
                    <div
                      className="mine-name"
                      onClick={jumpToLogin}
                      style={{ cursor: "pointer" }}
                    >
                      {t("common.name11")}
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="select-category">
              <div className="box-title">{t("store.name1")}</div>
              <div className="select-classify">
                {plateInfo.map((v, i) => {
                  return (
                    <div
                      className="menu-list"
                      key={i}
                      onClick={() => changePlateIndex(v.id)}
                      style={{
                        backgroundImage: `url(${contrastName(v.id)})`,
                      }}
                    >
                      <span
                        className="menu-title"
                        style={{
                          color: menuIndex === v.id ? "blue" : "black",
                        }}
                      >
                        {v.name}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div> */}
          <div className="homePage-threads">
            <div className="homePage-banner">
              <Carousel autoplay>
                {bannerList.map((v, i) => {
                  return (
                    <div
                      style={contentStyle}
                      onClick={() => bannerLink(v.urlType, v.url)}
                      key={v.id}
                    >
                      <img src={v.image} alt="" width="100%" height="100%" />
                    </div>
                  );
                })}
              </Carousel>
            </div>
            <Tabs
              defaultActiveKey={activeKey}
              activeKey={activeKey}
              onChange={(key) => changeTabIndex(key)}
            >
              <TabPane tab={t("common.name31")} key="1">
                <div className="content-box">
                  <div style={{ flex: 3 }}>
                    {!loading ? (
                      <>
                        {threadList.length ? (
                          threadList.map((v, i) => {
                            return (
                              <div className="thread-posts" key={v.tid}>
                                <div className="thread-header">
                                  <Avatar
                                    src={v.avatar}
                                    size={54}
                                    className="mine-avator"
                                    onClick={() => {
                                      jumpPage(v.authorId);
                                    }}
                                  />
                                  <div className="thread-desc">
                                    <div className="thread-name">
                                      {v.author}
                                    </div>
                                    <div className="thread-country">
                                      {v.vountry ? (
                                        <span>{v.country} |</span>
                                      ) : (
                                        ""
                                      )}
                                      {formatTime(v.createTime)}
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="thread-content"
                                  onClick={() =>
                                    navigate(`/detail?tid=${v.tid}`)
                                  }
                                >
                                  <div className="thread-title">
                                    {v.subject}
                                  </div>
                                  <div className="thread-text">{v.message}</div>
                                  <div className="thread-pic">
                                    {[1, null].includes(v.threadType) ? (
                                      v.attachment ? (
                                        <Thumbnail
                                          imgArr={[v.attachment]}
                                          width={v.width}
                                          height={v.height}
                                        />
                                      ) : null
                                    ) : (
                                      <div
                                        className="video-box"
                                        style={{
                                          height:
                                            v.width > v.height
                                              ? "240px"
                                              : "420px",
                                        }}
                                      >
                                        {v.videoThumb ? (
                                          <video
                                            poster={v.videoThumb}
                                            className="video-image"
                                          ></video>
                                        ) : (
                                          <video
                                            src={v.videoUrl}
                                            className="video-image"
                                          ></video>
                                        )}
                                        <img
                                          src={Pause}
                                          alt=""
                                          className="pause-img"
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="thread-footer">
                                  <div className="thread-operation">
                                    {/* 是否收藏 */}
                                    <div
                                      className="thread-func"
                                      onClick={() =>
                                        changePostFav(v.tid, v.isFavorite)
                                      }
                                    >
                                      {!v.isFavorite ? (
                                        <span className="iconfont icon-tubiao_Collect"></span>
                                      ) : (
                                        <span className="iconfont icon-a-shoucang-yishoucang"></span>
                                      )}
                                      <span className="func-count">
                                        {v.favTimes}
                                      </span>
                                    </div>
                                    <div
                                      className="thread-func"
                                      onClick={() =>
                                        changePostRate(v.pid, v.isRate)
                                      }
                                    >
                                      {/* 是否点赞 */}
                                      {!v.isRate ? (
                                        <span className="iconfont icon-tubiao_Favourite"></span>
                                      ) : (
                                        <span className="iconfont icon-aixin"></span>
                                      )}
                                      <span className="func-count">
                                        {v.rates}
                                      </span>
                                    </div>
                                    <div
                                      className="thread-func"
                                      onClick={() =>
                                        navigate(`/detail?tid=${v.tid}`)
                                      }
                                    >
                                      <span className="iconfont icon-tubiao_replay"></span>
                                      <span className="func-count">
                                        {v.replies}
                                      </span>
                                    </div>
                                    {/* <div className="thread-func">
                              <span className="iconfont icon-tubiao_Forward"></span>
                              <span className="func-count">90</span>
                            </div> */}
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={t("common.name22")}
                          />
                        )}
                        {threadLoading ? (
                          <div
                            style={{
                              width: "100%",
                              height: "200px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Spin
                              indicator={
                                <LoadingOutlined
                                  style={{ fontSize: 24 }}
                                  spin
                                />
                              }
                            />
                          </div>
                        ) : null}
                      </>
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          height: "200px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Spin
                          indicator={
                            <LoadingOutlined style={{ fontSize: 24 }} spin />
                          }
                        />
                      </div>
                    )}
                  </div>
                  <div className="right_layout">
                    <Button className="post_thread" onClick={() => toPost()}>
                      <img
                        src={postIcon}
                        width={30}
                        height={30}
                        className="post_image"
                      />
                      <div className="post_thread_text">
                        {t("new.PostThread")}
                      </div>
                    </Button>
                    <Button
                      className="feedback_layout"
                      onClick={() => {
                        navigate(`/feedback`);
                      }}
                    >
                      <img
                        src={FeedbackIcon}
                        width={30}
                        height={30}
                        className="feedback_image"
                      />
                      <div className="feedback_layout_text">
                        {t("new.Feedback")}
                      </div>
                    </Button>

                    <Button
                      className="video_layout"
                      onClick={() => {
                        navigate(`/video`);
                      }}
                    >
                      <img
                        src={VideoIcon}
                        width={30}
                        height={30}
                        className="video_image"
                      />
                      <div className="video_layout_text">{t("new.Video")}</div>
                    </Button>

                    <div className="post_recommended_users">
                      <div className="recommended_text">
                        {t("new.RecommendedUser")}
                      </div>
                      {recommendMember.map((value, i) => {
                        return (
                          <div
                            onClick={() => jumpPage(value.uid)}
                            className="recommended_content"
                          >
                            <img
                              src={value.avatar}
                              width={48}
                              height={48}
                              className="content_image"
                            />
                            <div className="content_text">{value.username}</div>
                          </div>
                        );
                      })}
                    </div>
                    <div className="topic_layout">
                      <div className="topic_text">
                        {t("new.RecommendedTopic")}
                      </div>
                      {topicList.map((v, i) => {
                        return (
                          <div
                            onClick={() => {
                              navigate(`/topic?topicId=${v.topicId}`);
                            }}
                            className="topic_content"
                          >
                            <img
                              src={Initial}
                              width={48}
                              height={48}
                              className="content_image"
                            />
                            <div className="topic_info_text">
                              # {v.topicName}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </TabPane>

              {tabList.length
                ? tabList.map((v, i) => {
                    return (
                      <TabPane tab={v.name} key={v.id}>
                        <div className="content-box">
                          {!loading ? (
                            <>
                              {threadList.length ? (
                                threadList.map((v, i) => {
                                  return (
                                    <div className="thread-posts" key={v.tid}>
                                      <div className="thread-header">
                                        <Avatar
                                          src={v.avatar}
                                          size={54}
                                          className="mine-avator"
                                          onClick={() => {
                                            jumpPage(v.authorId);
                                          }}
                                        />
                                        <div className="thread-desc">
                                          <div className="thread-name">
                                            {v.author}
                                          </div>
                                          <div className="thread-country">
                                            {v.vountry ? (
                                              <span>{v.country} |</span>
                                            ) : (
                                              ""
                                            )}
                                            {formatTime(v.createTime)}
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="thread-content"
                                        onClick={() =>
                                          navigate(`/detail?tid=${v.tid}`)
                                        }
                                      >
                                        <div className="thread-title">
                                          {v.subject}
                                        </div>
                                        <div className="thread-text">
                                          {v.message}
                                        </div>
                                        <div className="thread-pic">
                                          {[1, null].includes(v.threadType) ? (
                                            v.attachment ? (
                                              <Thumbnail
                                                imgArr={[v.attachment]}
                                                width={v.width}
                                                height={v.height}
                                              />
                                            ) : null
                                          ) : (
                                            <div
                                              className="video-box"
                                              style={{
                                                height:
                                                  v.width > v.height
                                                    ? "240px"
                                                    : "420px",
                                              }}
                                            >
                                              {v.videoThumb ? (
                                                <video
                                                  poster={v.videoThumb}
                                                  className="video-image"
                                                ></video>
                                              ) : (
                                                <video
                                                  src={v.videoUrl}
                                                  className="video-image"
                                                ></video>
                                              )}
                                              <img
                                                src={Pause}
                                                alt=""
                                                className="pause-img"
                                              />
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="thread-footer">
                                        <div className="thread-operation">
                                          {/* 是否收藏 */}
                                          <div
                                            className="thread-func"
                                            onClick={() =>
                                              changePostFav(v.tid, v.isFavorite)
                                            }
                                          >
                                            {!v.isFavorite ? (
                                              <span className="iconfont icon-tubiao_Collect"></span>
                                            ) : (
                                              <span className="iconfont icon-a-shoucang-yishoucang"></span>
                                            )}
                                            <span className="func-count">
                                              {v.favTimes}
                                            </span>
                                          </div>
                                          <div
                                            className="thread-func"
                                            onClick={() =>
                                              changePostRate(v.pid, v.isRate)
                                            }
                                          >
                                            {/* 是否点赞 */}
                                            {!v.isRate ? (
                                              <span className="iconfont icon-tubiao_Favourite"></span>
                                            ) : (
                                              <span className="iconfont icon-aixin"></span>
                                            )}
                                            <span className="func-count">
                                              {v.rates}
                                            </span>
                                          </div>
                                          <div
                                            className="thread-func"
                                            onClick={() =>
                                              navigate(`/detail?tid=${v.tid}`)
                                            }
                                          >
                                            <span className="iconfont icon-tubiao_replay"></span>
                                            <span className="func-count">
                                              {v.replies}
                                            </span>
                                          </div>
                                          {/* <div className="thread-func">
                              <span className="iconfont icon-tubiao_Forward"></span>
                              <span className="func-count">90</span>
                            </div> */}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })
                              ) : (
                                <Empty
                                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                                  description={t("common.name22")}
                                />
                              )}
                              {threadLoading ? (
                                <div
                                  style={{
                                    width: "100%",
                                    height: "200px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <Spin
                                    indicator={
                                      <LoadingOutlined
                                        style={{ fontSize: 24 }}
                                        spin
                                      />
                                    }
                                  />
                                </div>
                              ) : null}
                            </>
                          ) : (
                            <div
                              style={{
                                width: "100%",
                                height: "200px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Spin
                                indicator={
                                  <LoadingOutlined
                                    style={{ fontSize: 24 }}
                                    spin
                                  />
                                }
                              />
                            </div>
                          )}
                        </div>
                      </TabPane>
                    );
                  })
                : null}
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Store;
